(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-recipe"]) return;
  try {
    
  // .article-recipe .rte 内の table に含まれる tr 要素を取得
  let tables = document.querySelectorAll('.article-recipe .rte table');
  let rows = [];

  // 各 table の tr 要素を取得し、配列に追加
  tables.forEach(table => {
    let trElements = table.getElementsByTagName('tr');
    rows = rows.concat(Array.from(trElements));
  });

  let totalRows = rows.length;

  // 前半と後半の境界を計算（切り上げで半分に分ける）
  let midPoint = Math.ceil(totalRows / 2);
  console.log(midPoint);

  // 前半の要素に対する処理
  for (let i = 0; i < midPoint; i++) {
    rows[i].style.order = (2 * i + 1); // order を 2n+1 の形で指定
  }

  // 後半の要素に対する処理
  for (let i = midPoint; i < totalRows; i++) {
    rows[i].style.order = (2 * (i - midPoint) + 2); // 後半の要素には2nの形で指定
  }

  // `rows[midPoint - 1]`にクラスを追加
  rows[midPoint - 1].classList.add('bottom');
  // 一番最後の要素にクラスを追加
  rows[totalRows - 1].classList.add('bottom');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
//タグのカレント表示
const host = location.host;
let url = location.href;
if(url.indexOf('/tagged/') !== -1){
  url = url.split(host)[1];
  $('.main-blog__tagfilter_select option').each(function(){
    let tgt = encodeURI($(this).val());
    if(tgt === url){
      $(this).attr('selected', 'selected');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onlineshop-slide"]) return;
  try {
    
    const top_fv_swiper = new Swiper('.onlineshop-slide .swiper', {
    slidesPerView: "auto",
    centeredSlides : true,
    spaceBetween: '2%',
    loop: true,
    initialSlide: 0,
    autoplay: { delay: 4000, disableOnInteraction: false },
    speed: 700,
    pagination: false,
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
  });
  (function(){
    var pg = document.querySelector('.onlineshop-slide .swiper-pagination'); if (!pg) return;
    var nR = document.querySelectorAll('.onlineshop-slide .swiper-slide:not([data-kk-clone])').length;
    pg.innerHTML = Array.from({length: nR}, function(_, k){ return '<span class="swiper-pagination-bullet' + (k === 0 ? ' swiper-pagination-bullet-active' : '') + '" data-k="' + k + '"></span>'; }).join('');
    pg.addEventListener('click', function(e){ var d = e.target.closest('.swiper-pagination-bullet'); if (d) top_fv_swiper.slideToLoop(+d.dataset.k); });
    top_fv_swiper.on('realIndexChange', function(){ pg.querySelectorAll('.swiper-pagination-bullet').forEach(function(d, k){ d.classList.toggle('swiper-pagination-bullet-active', k === top_fv_swiper.realIndex % nR); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-shop"]) return;
  try {
    
    const cafe_restaurant__gallery = new Swiper('.cafe_restaurant__gallery .swiper', {
      slidesPerView: "auto",
      spaceBetween: 22,
      speed: 7500,
      loop: true,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        990: {
          spaceBetween: "3.1%",
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-top"]) return;
  try {
    
  // モーダル機能
  let close = $('.js-modal-close');
  let container = $('.js-modal-container');
  // 閉じるボタンをクリックしたらモーダルを閉じる
  close.on('click', function(){	
    container.removeClass('active');
  });

  // GSAPのタイムラインを作成
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.concept',
      start: 'top 50%',
      toggleActions: "play none none reverse",
    }
  });

  // タイムラインにアニメーションを追加
  tl.fromTo('.fv', 
    { autoAlpha: 1 },
    { 
      autoAlpha: 0,
      duration: 0.25,
      ease: Power1.easeInOut
    }
  )
  .fromTo('.concept', 
    { y: 10, autoAlpha: 0 },
    { 
      y: 0, 
      autoAlpha: 1,
      duration: 0.5,
      ease: Power1.easeInOut
    },
    "-=0.25" // 前のアニメーションと重ならないようにする
  )
  // 各要素のアニメーションを順番に追加
  .fromTo('.concept .concept__title.ja', 
    { y: 5, autoAlpha: 0 },
    {
      y: 0, 
      autoAlpha: 1, 
      duration: 0.5, 
      ease: Power1.easeInOut 
    }, 
    "-=0.1" // 少し前倒しに開始
  )
  .fromTo('.concept .concept__description.ja', 
    { y: 5, autoAlpha: 0 },
    { 
      y: 0, 
      autoAlpha: 1, 
      duration: 0.5, 
      ease: Power1.easeInOut 
    }, 
    "-=0.25" // 前のアニメーションの中間で開始
  )
  .fromTo('.concept .concept__title.en', 
    { y: 5, autoAlpha: 0 },
    { 
      y: 0, 
      autoAlpha: 1, 
      duration: 0.5, 
      ease: Power1.easeInOut 
    }, 
    "-=0.25" 
  )
  .fromTo('.concept .concept__description.en', 
    { y: 5, autoAlpha: 0 },
    { 
      y: 0, 
      autoAlpha: 1, 
      duration: 0.5, 
      ease: Power1.easeInOut 
    }, 
    "-=0.25" 
  );

  // 他の既存のアニメーション
  gsap.fromTo('.top_concept_ob_1', {
    x: -50,
  },
  {
    x: 0,
    duration: 7.5,
    ease: Power1.easeInOut,
    repeat: -1,
    yoyo: true,
    scrollTrigger: {
      trigger: '.concept',
      start: 'top 50%',
    }
  });

  gsap.fromTo('.top_concept_ob_2', {
    x: 50,
  },
  {
    x: 0,
    duration: 7.5,
    ease: Power1.easeInOut,
    repeat: -1,
    yoyo: true,
    scrollTrigger: {
      trigger: '.concept',
      start: 'top 50%',
    }
  });

  gsap.fromTo('.concept .common_logomark', {
    y: 10,
    autoAlpha: 0,
  },
  {
    y: 0,
    autoAlpha: 1,
    duration: 0.75,
    ease: Power1.easeInOut,
    scrollTrigger: {
      trigger: '.concept',
      start: 'top 50%',
    }
  });

  } catch(e) { console.error(e); }
})();
})();
